import { startOfDay, addDays, subDays } from 'date-fns';
import { useMemo } from 'react';

const useSelectedDays = ({
  enableFuture,
  selectedDay,
  range,
}: {
  enableFuture?: boolean;
  selectedDay?: Date | null;
  range: number;
}) => {
  const dates = useMemo(() => {
    const today = startOfDay(new Date());
    const yesterday = subDays(today, 1);
    const defaultStart = enableFuture ? today : yesterday;
    const start = selectedDay ? startOfDay(selectedDay) : defaultStart;
    const end = addDays(start, range - 1);

    return {
      start,
      end,
    };
  }, [enableFuture, selectedDay, range]);

  return dates;
};

export default useSelectedDays;
